/*
 * @Author: Teemo Ding
 * @Date: 2022-04-17 13:48:20
 * @LastEditTime: 2023-02-21 17:20:21
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Analytics/Reports/ReportsDetail/Table/index.tsx
 */
import TableCom from '@/src/components/EditableTable/EditableTable';
import { IReportCurrencyType } from '@/src/types/common/report';
import { Form } from 'antd';
import { get } from 'lodash';
import React, { Fragment } from 'react';
import { useParams } from 'react-router';
import GlobalPagination from 'src/components/StyledPagination/GlobalPagination';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import { i18nGet } from 'src/tools/tools';
import { columns } from '../config';
import css from '../css.module.less';
import { Skeleton } from '@/src/components/Antd';

const Table = (props: any) => {
  const {
    results,
    pageSize,
    setPageSize,
    total,
    current,
    setCurrent,
    loading,
  } = props;
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const pageSizeOption = [1000, 2500, 5000];
  const { type } = useParams() as any;
  const pageOnChange = (page, pageSize) => {
    setCurrent(page - 1);
  };
  const pageSizeChange = (value) => {
    setPageSize(value.value);
    setCurrent(0);
  };

  const resultsAll = (dimensions, metrics, reportCurrencyType) => {
    const all = (metrics || []).reduce((pre, now) => {
      pre[now.type] =
        reportCurrencyType === IReportCurrencyType.TransactionNativeCurrency &&
        now.rollup !== 0 &&
        !now.rollup
          ? 'N/A'
          : now.rollup;
      return pre;
    }, {});
    return [
      {
        [get(dimensions, ['0', 'type'])]: '',
        ...all,
      },
      ...results,
    ];
  };

  return (
    <SectionWrapper
      containerClassName={css.sectionContainer}
      titleClassName={css.titleClassName}
      title={getI18n('reports.reportpagecommon.table')}>
      <Form.Item
        noStyle
        shouldUpdate={(prevValues, curValues) => {
          return (
            prevValues.dimensions !== curValues.dimensions ||
            prevValues.metrics !== curValues.metrics ||
            prevValues.reportCurrencyType !== curValues.reportCurrencyType
          );
        }}>
        {({ getFieldValue }: any) => {
          const dimensions = (getFieldValue('dimensions') || []).filter(
            (o) => o.checked,
          );
          const metrics = (getFieldValue('metrics') || []).filter(
            (o) => o.checked,
          );

          return (
            <Fragment>
              <Skeleton loading={loading} active rows={20}>
                <TableCom
                  id='reportTable'
                  rowKey='index'
                  bordered
                  rowClassName={(_, index) =>
                    index === 0 ? css.summary : css.tr
                  }
                  columns={columns(dimensions, metrics, type, { getI18n })}
                  dataSource={resultsAll(
                    dimensions,
                    metrics,
                    getFieldValue('reportCurrencyType'),
                  )}
                />
                {!!(results || []).length && (
                  <GlobalPagination
                    pageOnChange={pageOnChange}
                    totalText={getI18n('reports.table.metrics.totaltext')}
                    pageSize={pageSize}
                    pageSizeOption={pageSizeOption}
                    pageSizeChange={pageSizeChange}
                    total={total}
                    current={current + 1}
                    paginationProps={{
                      defaultPageSize: pageSize,
                      showQuickJumper: true,
                    }}
                    pageSizeWidth={120}
                    setCurrent={setCurrent}
                  />
                )}
              </Skeleton>
            </Fragment>
          );
        }}
      </Form.Item>
    </SectionWrapper>
  );
};

export default Table;
